<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { snackbar, dialog } = storeToRefs(store)

const SetSnackbar = store.SetSnackbar
const SetDialog = store.SetDialog

const teleportTarget = ref<Element | null>(null)

onMounted(() => {
  const host = document.getElementById('one-800-products-modal-host')
  if (host && host.shadowRoot) {
    teleportTarget.value = host.shadowRoot.getElementById('app-modal-root')
  }
})
</script>

<template>
  <Teleport :to="teleportTarget" v-if="teleportTarget">
    <div>
      <v-snackbar v-model="snackbar.visible" :color="snackbar.type">
        <template v-if="snackbar.icon">
          <v-icon class="mr-2">{{ snackbar.icon }}</v-icon>
        </template>
        <span v-html="snackbar.content"></span>
        <template v-slot:actions>
          <v-btn variant="text" @click="SetSnackbar({ visible: false, content: '' })" icon="mdi-close"></v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="dialog.visible" width="600">
        <v-card>
          <v-card-title>{{ dialog.title }}</v-card-title>
          <v-card-text>{{ dialog.content }}</v-card-text>
          <v-card-actions>
            <v-btn style="color:#ffffff" @click="SetDialog({ visible: false, title: '', content: '' })" icon="mdi-close">
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </Teleport>
</template>
